import React from 'react';
import MediaQuery from 'react-responsive';
import { MOBILE_BREAKPOINT } from '../constants';

export const NotMobile = (props) => (
  <MediaQuery minWidth={MOBILE_BREAKPOINT}>{props.children}</MediaQuery>
);

export const Mobile = (props) => (
  <MediaQuery maxWidth={MOBILE_BREAKPOINT}>{props.children}</MediaQuery>
);
